import { resizeImage } from "./image.service";

export class CameraService {
	private stream: MediaStream | null = null;

	async start(video: HTMLVideoElement): Promise<void> {
		const stream = await navigator.mediaDevices.getUserMedia({
			video: {
				facingMode: { ideal: "environment" },
				width: { ideal: 1280 },
			},
			audio: false,
		});

		this.stop();
		this.stream = stream;
		video.srcObject = stream;
	}

	capture(video: HTMLVideoElement): string | null {
		if (!video.videoWidth) return null;
		return resizeImage(video, video.videoWidth, video.videoHeight);
	}

	stop(): void {
		this.stream?.getTracks().forEach((track) => {
			track.stop();
		});
		this.stream = null;
	}
}
